import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import { Modal, ModalHeader, ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import SlideForm from '../slide-form/slide-form'

const ExemplarSlideEditDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  title,
  description,
  onDelete,
  updating,
  deleting,
  descriptionHTML
}) => (
  <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
    <ModalHeader>Edit exemplar slide</ModalHeader>
    <SlideForm
      onSubmit={onSubmit}
      initialValues={{ title: title || '', description: descriptionHTML || '' }}
      footer={({ isValid }) => (
        <ModalFooter alignRight childrenGap>
          <Button action={onClose} tall simple>
            Cancel
          </Button>
          <Button tall type="submit" disabled={updating || !isValid}>
            {!updating && 'Save'}
            {updating && 'Saving...'}
          </Button>
        </ModalFooter>
      )}
    />
  </Modal>
)

export default injectSheet(styles)(ExemplarSlideEditDialog)
